<template>
    <div>
        <div class="diagram-one-wrap" :style="{ height: winHeight - 140 + 'px' }" ref="total">
            <div id="main" ref="main" class="total-wrap">
                <div id="canvas" ref="canvas" class="canvas-wrap" :style="`transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                    ">
                    <img class="bg-img" src="../../../../assets/image/app/diagram_bwg1.png" alt srcset />
                    <div v-for="item in datas" :key="item.point_id" class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;width:${item.width}rem;height:${item.height}rem`"
                        @click="showDialog(item)">
                    </div>
                    <div class="data_dialog" v-if="curItem"
                        :style="`top:calc(${curItem.top - 1}% + ${curItem.height + 0.5}rem);left:calc(${curItem.left}% - ${curItem.width/2}rem);`">
                        <div class="data-item">
                            <div><i>电压(V)：</i></div>
                            <div><span class="red">A:</span>{{curItem.va}}</div>
                            <div><span class="green">B:</span>{{curItem.vb}}</div>
                            <div><span class="yellow">C:</span>{{curItem.vc}}</div>
                        </div>
                        <div class="data-item">
                            <div><i>电流(A)：</i></div>
                            <div><span class="red">A:</span>{{curItem.ia}}</div>
                            <div><span class="green">B:</span>{{curItem.ib}}</div>
                            <div><span class="yellow">C:</span>{{curItem.ic}}</div>
                        </div>
                        <div class="data-item">
                            <div><i>功率(kW)：</i></div>
                            <div><span class="red">A:</span>{{curItem.pa}}</div>
                            <div><span class="green">B:</span>{{curItem.pb}}</div>
                            <div><span class="yellow">C:</span>{{curItem.pc}}</div>
                        </div>
                        <div class="data-item">
                            <div><i>总功率(kW)：</i></div>
                            <div><span class="yellow"></span>{{curItem.p}}</div>
                        </div>
                        <div class="dialog_close" @click="closeDialog(item)">X</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from "@/http/api-runtime.js";
export default {
    components: {},
    data() {
        return {
            left: "0",
            top: "-20",
            scale: 0.9,
            width: 1200,
            height: 1000,
            winHeight: 0,
            timer: null,
            curItem: null,
            datas: [
                {
                    name: "AH1 主配 #2变906",
                    point_id: "1465522289318600704",
                    top: 10,
                    left: 17,
                    width: 11,
                    height: 6,
                },
                {
                    name: "#1变903",
                    point_id: "1465523973612675072",
                    top: 10,
                    left: 53,
                    width: 11,
                    height: 6,
                },
                {
                    name: "#3变905",
                    point_id: "1465524085181161472",
                    top: 10,
                    left: 73,
                    width: 11,
                    height: 6,
                },
                {
                    name: "402#2变进线开关计量",
                    point_id: "1466603576397713408",
                    top: 26,
                    left: 20,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "#1分配904",
                    point_id: "1465522457094955008",
                    top: 26,
                    left: 40,
                    width: 8,
                    height: 5.5,
                },
                {
                    name: "401#1变进线开关",
                    point_id: "1465926956099866624",
                    top: 26,
                    left: 56,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "403#3变进线开关计量",
                    point_id: "1466645979766771712",
                    top: 26,
                    left: 76,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "#1分配 #1变902",
                    point_id: "1628c53175a14c1094657e5fbe683aad",
                    top: 44,
                    left: 2,
                    width: 11,
                    height: 6,
                },
                {
                    name: "#1分配 #2变903",
                    point_id: "910e4da63a0a40d9afe08338bfa7d68d",
                    top: 44,
                    left: 18,
                    width: 11,
                    height: 6,
                },
                {
                    name: "#1分配 #3变904",
                    point_id: "9d97ed0be11c4b348a5364a9dadbf1de",
                    top: 44,
                    left: 36,
                    width: 11,
                    height: 6,
                },
                {
                    name: "#1分配 #4变905",
                    point_id: "191e37f359a942f9862aba87d02221d9",
                    top: 44,
                    left: 55,
                    width: 11,
                    height: 6,
                },
                {
                    name: "#1变401/039",
                    point_id: "b3c1dcf1281d4997bd95b63bf5713ff4",
                    top: 64,
                    left: 1,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "光伏",
                    point_id: "",
                    top: 64,
                    left: 8,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "#2变402  总开关/039",
                    point_id: "8d0f0323918b48ccb51c22cc219181ca",
                    top: 64,
                    left: 18,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "光伏",
                    point_id: "",
                    top: 64,
                    left: 24,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "3#403   总开关/039",
                    point_id: "4a269ea643574109b2ccd8ea9086f216",
                    top: 64,
                    left: 36,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "光伏",
                    point_id: "",
                    top: 64,
                    left: 43,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "4#404  总开关/039",
                    point_id: "d2a1ef401beb48c9a8e7d34038f25a0b",
                    top: 64,
                    left: 54,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "光伏",
                    point_id: "",
                    top: 64,
                    left: 61,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "并网柜1",
                    point_id: "1694514394265968640",
                    top: 86,
                    left: 5,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "并网柜2",
                    point_id: "1694515869994082304",
                    top: 86,
                    left: 11,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "并网柜3",
                    point_id: "1694516000688594944",
                    top: 86,
                    left: 21,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "并网柜4",
                    point_id: "1694516134243622912",
                    top: 86,
                    left: 27,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "并网柜5",
                    point_id: "1694516262157312000",
                    top: 86,
                    left: 43,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "并网柜6",
                    point_id: "1694516514520195072",
                    top: 86,
                    left: 55,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "并网柜7",
                    point_id: "1694516642161254400",
                    top: 86,
                    left: 62,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "并网柜8",
                    point_id: "1694516751854886912",
                    top: 86,
                    left: 67,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "#2分配电室901*",
                    point_id: "6e50a6f36936476781e24cb984197adf",
                    top: 42,
                    left: 79,
                    width: 8,
                    height: 5.5,
                },
                {
                    name: "#2分配 #1变902",
                    point_id: "bf8e8b3939384c6c84881ddd561f3410",
                    top: 56,
                    left: 72,
                    width: 11,
                    height: 6,
                },
                {
                    name: "#2分配 #2变903",
                    point_id: "657315dce1fe452bae956adfa962e1c2",
                    top: 56,
                    left: 85,
                    width: 11,
                    height: 6,
                },
                {
                    name: "#1变进线计量401",
                    point_id: "80279818720c4411baa2d74f6c58fc88",
                    top: 71,
                    left: 72,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "光伏",
                    point_id: "",
                    top: 71,
                    left: 78,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "#2变进线计量402",
                    point_id: "822bbfe04802442cbebe90423da8b3ae",
                    top: 71,
                    left: 88,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "并网柜9",
                    point_id: "1694516897531453440",
                    top: 86,
                    left: 75,
                    width: 5,
                    height: 5.5,
                },
                {
                    name: "并网柜10",
                    point_id: "1694517034207043584",
                    top: 86,
                    left: 81,
                    width: 5,
                    height: 5.5,
                },
            ],
        };
    },
    created() {
        if (window.innerHeight) this.winHeight = window.innerHeight;
        else if (document.body && document.body.clientHeight)
            this.winHeight = document.body.clientHeight;
    },

    mounted() {
        this.zoom();
        this.drag();
        this.setTimer();
        // 获取mo实时电数据
        this.getMoElecData();
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                // 获取mo实时电数据
                this.getMoElecData();
            }, 1000 * 60);
        },
        showDialog(item) {
            if(item.point_id) this.curItem = item;
        },
        closeDialog(item) {
            this.curItem = null;
        },
        /**
        * @description: 获取mo实时电数据
        */
        getMoElecData() {
            let pointIds = [];
            this.datas.forEach(item => {
                if(item.point_id) pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.datas.forEach(item => {
                    let point = valueJson[item.point_id];

                    item.ia = point && point["a_a"] && this.fixedString(point["a_a"], 2);
                    item.ib = point && point["a_b"] && this.fixedString(point["a_b"], 2);
                    item.ic = point && point["a_c"] && this.fixedString(point["a_c"], 2);

                    item.va = point && point["v_a"] && this.fixedString(point["v_a"], 2);
                    item.vb = point && point["v_b"] && this.fixedString(point["v_b"], 2);
                    item.vc = point && point["v_c"] && this.fixedString(point["v_c"], 2);
                    
                    item.pa = point && point["p_a"] && this.fixedString(point["p_a"], 2);
                    item.pb = point && point["p_b"] && this.fixedString(point["p_b"], 2);
                    item.pc = point && point["p_c"] && this.fixedString(point["p_c"], 2);

                    item.p = point && point["p"] && this.fixedString(point["p"], 2);
                })
            })
        },
        /**
        * @description: 保留几位小数  number位数
        */
        fixedString(value, number) {
            let val = value + "";
            if (number == 0) {
                const arr = val.split(".");
                if (arr.length > 0) {
                    return arr[0];
                } else {
                    return "";
                }
            }
            return val.substring(0, val.indexOf(".") + (1 + number));

        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function (event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function (event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function (en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function (en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function () {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
.diagram-one-wrap {
    background-color: #09292f;
    width: 98%;
    overflow: hidden;
    position: relative;
    left: 50%;
    transform: translateX(-50%);

    .total-wrap {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: move;

        .canvas-wrap {
            width: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }

        .total-title {
            color: #fff;
            position: absolute;
            font-size: 24px;
            text-align: center;
            top: 1%;
            left: 50%;
            transform: translateX(-50%);
        }

        .bg-img {
            width: 100%;
        }

        .data-wrap {
            position: absolute;
            display: grid;
            transform: scale(1);
            cursor: pointer;
            background: transparent;
        }

        .data_dialog {
            position: absolute;
            width: 23rem;
            height: 10rem;
            padding: 1.5rem 1rem;
            box-sizing: border-box;
            background: url("../../../../assets/image/app/data_dialog_back.png") no-repeat;
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
            display: inline-flex;
            flex-flow: column wrap;
            justify-content: space-between;

            .dialog_close {
                position: absolute;
                top: 0.5rem;
                right: 1.5rem;
                font-size: 1rem;
                font-weight: bold;
                color: #fff;
                z-index: 9;
                cursor: pointer;
            }

            .data-item {
                // display: flex;
                //  margin-bottom: 0.2rem;
                flex: 1;
                border-bottom: 1px dotted #1aa7ee;
                // &:not(:last-child) {
                //     border-bottom: 1px dotted #1aa7ee;
                // }
                display: inline-flex;
                align-items: center;
                
                div {
                    &:first-child {
                        width: 5rem;
                    }
                    &:not(:first-child) {
                        width: calc(33.3% - 1.15rem);
                    }
                   // flex: 1;
                    color: #fff;
                    font-size: 0.8rem;
                }

                .data-name {
                    align-self: center;
                    font-size: 1rem;
                    margin-right: 0.1rem;
                    width: 1rem;
                    text-align: right;
                    font-weight: bold;
                }

                .data-number {
                    font-size: 0.8rem;
                    width: 5rem;
                    text-align: right;
                    background-color: #0e4b69;
                    // margin-left: 0.5rem;
                    color: #fff;
                    height: 1rem;
                    line-height: 1rem;

                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                }

                .red {
                    color: #fe0101;
                }

                .yellow {
                    color: #fefa00;
                }

                .green {
                    color: #00b200;
                }
            }

            .data-item-temp {
                display: flex;
                margin-bottom: 0.3rem;

                .data-name-temp {
                    align-self: center;
                    font-size: 0.8rem;
                    margin-right: 0.1rem;
                    width: 0.8rem;
                    text-align: right;
                    font-weight: bold;
                }

                .data-number-temp {
                    font-size: 0.7rem;
                    width: 3rem;
                    text-align: right;
                    background-color: #3db9f7;
                    color: #fff;
                    height: 0.8rem;
                    line-height: 0.8rem;

                    //  margin-left:0.5rem;
                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                }

                .red {
                    color: #fe0101;
                }

                .yellow {
                    color: #fefa00;
                }

                .green {
                    color: #00b200;
                }
            }
        }
    }

    i {
        color: #3db9f7;
    }
}</style>
